(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('obvious-product-carousel')) {
  customElements.define('obvious-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.index = 0;
      this.timer = null;
      this.started = false;
      this.listen = (target, name, handler, options = {}) => target.addEventListener(name, handler, {...options, signal: this.abort.signal});
      this.listen(document, 'page:loaded', () => this.start());
      this.listen(window, 'load', () => this.start());
      this.startDelay = setTimeout(() => this.start(), 0);
    }
    start() {
      if (this.started || !this.isConnected || !window.theme?.sections || !window.theme?.Product) return;
      this.started = true;
      this.slides = [...this.querySelectorAll('.opc-slide')];
      this.controls = this.querySelector('.opc-controls');
      this.status = this.querySelector('[data-status]');
      this.thumbnails = [...this.querySelectorAll('[data-slide-index]')];
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches || Boolean(window.Shopify?.designMode);
      this.slides.forEach(slide => {
        const product = slide.querySelector('[data-section-type="product"]');
        if (product && !theme.sections._findInstance(product.dataset.sectionId)) theme.sections._createInstance(product, theme.Product);
      });
      if (this.slides.length < 2) return;
      this.controls.hidden = false;
      this.show(0);
      this.classList.add('opc-ready');
      this.thumbnails.forEach(button => this.listen(button, 'click', () => {this.pause();this.status.setAttribute('aria-live','polite');this.show(Number(button.dataset.slideIndex));}));
      this.listen(this, 'mouseenter', () => {this.hovered = true; this.stop();});
      this.listen(this, 'mouseleave', () => {this.hovered = false; this.schedule();});
      this.listen(this, 'focusin', event => {if (!this.controls.contains(event.target)) this.pause();});
      this.listen(this, 'focusout', () => {this.focusDelay = setTimeout(() => this.schedule(), 0);});
      this.listen(this, 'change', () => this.pause());
      this.listen(this, 'submit', () => this.pause(), {capture:true});
      this.listen(this, 'pointerdown', event => {if (!this.controls.contains(event.target)) this.pause();});
      this.listen(this, 'touchstart', event => {
        this.touch = null;
        if (event.target.closest('a,button,input,select,textarea,[data-product-photos],[data-product-thumbs]')) return;
        if (event.touches.length === 1) this.touch = {x:event.touches[0].clientX,y:event.touches[0].clientY};
      }, {passive:true});
      this.listen(this, 'touchend', event => {
        if (!this.touch || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX-this.touch.x;
        const dy = event.changedTouches[0].clientY-this.touch.y;
        this.touch = null;
        if (Math.abs(dx)>70 && Math.abs(dx)>Math.abs(dy)*1.5) this.manual(dx<0?1:-1);
      }, {passive:true});
      this.listen(document, 'visibilitychange', () => this.schedule());
      this.listen(this.reduced, 'change', () => {if(this.reduced.matches)this.pause();});
      this.observer = new IntersectionObserver(entries => {this.visible = entries[0].isIntersecting;this.schedule();}, {threshold:0.1});
      this.observer.observe(this);
    }
    stop() {clearTimeout(this.timer);this.timer=null;}
    pause() {this.paused=true;this.stop();}
    schedule() {
      this.stop();
      if(this.paused || this.hovered || !this.visible || document.hidden || (this.contains(document.activeElement) && !this.controls.contains(document.activeElement)) || this.slides.length<2)return;
      this.timer=setTimeout(() => {this.show(this.index+1);this.schedule();},Number(this.dataset.interval)||7000);
    }
    manual(direction) {this.pause();this.status.setAttribute('aria-live','polite');this.show(this.index+direction);}
    show(index) {
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i) => {const active=i===this.index;slide.classList.toggle('opc-active',active);slide.inert=!active;slide.setAttribute('aria-hidden',String(!active));});
      this.thumbnails.forEach((button,i) => button.setAttribute('aria-current',String(i===this.index)));
      this.status.textContent=this.slides[this.index].getAttribute('aria-label');
      window.dispatchEvent(new Event('resize'));
      window.AOS?.refresh();
    }
    disconnectedCallback() {
      this.stop();clearTimeout(this.startDelay);clearTimeout(this.focusDelay);this.abort?.abort();this.observer?.disconnect();
      this.slides?.forEach(slide => {const product=slide.querySelector('[data-section-type="product"]');const id=product?.dataset.sectionId;const instance=id&&window.theme?.sections?._findInstance(id);if(instance){instance.onUnload?.();theme.sections._removeInstance(id);}});
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
